module.exports = __webpack_public_path__ + "a0923ddc3c8abed20bfdfbd559c8d7b0.svg";